const enTranslation = require('./en/translation.json');
const elTranslation = require('./gr/translation.json');
const enTags = require('./en/tags.json');
const elTags = require('./gr/tags.json');


const resources = {
  en: {
    translation: enTranslation,
    tags: enTags,
  },
  gr: {
    translation: elTranslation,
    tags: elTags,
  },
};

export default resources;
